import styled, { css } from "styled-components"

export default {
    "Wrapper": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 120px 28px 0 28px;
        gap: 60px;
    `,

    "LogoImg": styled.img`
        width: 128px;
        cursor: pointer;
    `,

    "LoginForm": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
    `,
    "ShowButton": styled.button`
        display: flex;
        align-items: center;
    `,
    "LoginButtonDiv": styled.div`
        width: 100%;
    `,

    "ControlDiv": styled.div`
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 12px;
    `,
    "ButtonDiv": styled.div`
        width: fit-content;
        display: flex;
        gap: 8px;
        ${({ theme }) => theme.font["small-semibold"]};

        & > button {
            ${({ theme }) => theme.font["small-semibold"]};
        }
    `,
    "SignupButton": styled.button`
        ${({ theme }) => theme.font["xlarge-bold"]};
    `,

    "SnsSignupDiv": styled.div`
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 12px;
    `,
    "SnsLabel": styled.p`
        ${({ theme }) => theme.font["medium-medium"]};
    `,
    "SnsButton": styled.button`
        min-width: 44px;
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        ${({ theme }) => theme.font["large-semibold"]};
        border-radius: 4px;

        ${({ $kakao }) => $kakao && css`
            background-color: #FEE500;
        `}

        ${({ $google }) => $google && css`
            border: 1px solid ${({ theme }) => theme.color["grey3"]};
        `}

        ${({ $apple }) => $apple && css`
            background-color: ${({ theme }) => theme.color["black"]};
            padding-bottom: 3px;
        `}

        & > img {
            height: 22px;
        }
    `,

}